import * as Styled from './GhostButton.styled';
import type { ButtonProps } from '../Button.types';
import React from 'react';

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (props, ref) => {
    const {
      inline = false,
      children,
      intent = 'primary',
      leading,
      trailing,
      ...rest
    } = props;
    return (
      <Styled.Button ref={ref} intent={intent} inline={inline} {...rest}>
        {!!leading && <Styled.Leading>{leading}</Styled.Leading>}
        {children}
        {!!trailing && <Styled.Trailing>{trailing}</Styled.Trailing>}
      </Styled.Button>
    );
  },
);

export default Button;
